import React, { FC, useRef, useState } from 'react'
import './drop-down.css'

// UTILITIES
import { flatten } from '@utils/string-helper'
import { useTouchUpOutside } from '@hooks/bounding-boxes'


interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
    children: [React.ReactNode, React.ReactNode]
    state?: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
    bind?: 'left' | 'right'
    contentStyle?: React.CSSProperties
}

const DropDown: FC<Props> = (props) => {
    const { className: classProps, children, state = useState<boolean>(false), bind, contentStyle, ...divProps } = props
    const [isOpen, setIsOpen] = state
    const dropDownRef = useRef<HTMLDivElement>(null)

    useTouchUpOutside(dropDownRef, () => {
        if (isOpen) setIsOpen(false)
    }, [setIsOpen, isOpen])

    return (
        <div ref={dropDownRef} className={flatten("drop-down", classProps)} {...divProps}>
            <div className="trigger" onClick={() => { setIsOpen(!isOpen) }}>
                {children[0]}
            </div>
            <div className={flatten("content", bind, isOpen ? "open" : "closed")} style={contentStyle} onClick={(e) => { e.stopPropagation() }}>
                {children[1]}
            </div>
        </div>
    )
}

export default DropDown